
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(121|216|497)|7(75[04]|044|64)|9(29|390|742|969)|1434|3597|5891|6314|8666)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
